import styled from "styled-components";
import { TextXL } from "../../common/text";
import { Swiper } from "swiper/react";
import { NavLink } from "react-router-dom";
import { IoLogOut } from "react-icons/io5";

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 60px;
  @media ${({ theme }) => theme.device.tablet} {
    height: 80px;
  }
`;

export const Title = styled(TextXL)`
  text-align: center;
  font-size: 23px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 30px;
  }
`;

export const PosterWrapper = styled(Swiper)`
  width: 90%;
  height: 70%; // 갤럭시는 밑에 공간 필요 없음
  ${({ isios }) =>
    isios === "true" && "height: 67%;"}; // ios 는 사파리때문에 밑에 공간 확보
  border-radius: 12px;
  background-color: #ffffff;
  .swiper-pagination-bullet-active {
    background-color: #f44b59;
  }
  @media ${({ theme }) => theme.device.tablet} {
    width: 65%;
  }

  @media ${({ theme }) => theme.device.iphoneMini} {
    ${({ isios }) =>
      isios === "true" && "height: 64%;"}// iphone mini 일때는 height 작게해야함
  }
`;

export const PosterImg = styled.img`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  @media ${({ theme }) => theme.device.tablet} {
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 90%;
  height: 60px;
  margin-top: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 65%;
    height: 7%;
    gap: 15px;
    margin-top: 40px;
  }
`;

export const Button = styled.div`
  width: 50%;
  height: 100%;

  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: rgba(180, 180, 180, 0.1);
  border-radius: 7px;
  @media ${({ theme }) => theme.device.tablet} {
    border-radius: 10px;
    gap: 20px;
  }
`;

// 하단 Navigation bar 제작 (230331)

export const NavContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  box-shadow: 0px 0px 20px 0px rgba(14, 30, 37, 0.32);
  background-color: #ffffff;
  position: fixed;
  width: 100%;
  height: ${({ isios }) => (isios ? "70px" : "60px")};
  padding-top: ${({ isios }) => (isios ? "5px" : "none")};
  padding-bottom: ${({ isios }) => (isios ? "20px" : "none")};
  @media ${({ theme }) => theme.device.tablet} {
    height: ${({ isios }) => (isios ? "90px" : "70px")};
    padding-top: ${({ isios }) => (isios ? "7px" : "none")};
    padding-bottom: ${({ isios }) => (isios ? "25px" : "none")};
  }
  @media ${({ theme }) => theme.device.laptop} {
    height: 70px;
  }
  bottom: 0;
  left: 0;
  right: 0;
`;

export const NavWrapper = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
`;

export const ButtonIcon = styled.img`
  width: 20px;
  height: 20px;

  @media ${({ theme }) => theme.device.tablet} {
    width: 25px;
    height: 25px;
  }
`;

export const MyTicketIcon = styled.img.attrs((props) => ({
  src: process.env.PUBLIC_URL + "/icons/ticket01.png",
}))`
  width: 20px;
  height: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 25px;
    height: 25px;
  }
`;

export const LogOutIcon = styled(IoLogOut)`
  font-size: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 25px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 25px;
  }
`;
